var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMomentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6797 1.40625H14.0625V0.5625C14.0625 0.251859 13.8107 0 13.5 0C13.1893 0 12.9375 0.251859 12.9375 0.5625V1.40625H5.0625V0.5625C5.0625 0.251859 4.81068 0 4.5 0C4.18932 0 3.9375 0.251859 3.9375 0.5625V1.40625H2.32031C1.04087 1.40625 0 2.44712 0 3.72656V15.6797C0 16.9591 1.04087 18 2.32031 18H15.6797C16.9591 18 18 16.9591 18 15.6797V3.72656C18 2.44712 16.9591 1.40625 15.6797 1.40625ZM16.875 15.6797C16.875 16.3399 16.3399 16.875 15.6797 16.875H2.32031C1.66015 16.875 1.125 16.3399 1.125 15.6797V6.36328C1.125 6.26621 1.20371 6.1875 1.30078 6.1875H16.6992C16.7963 6.1875 16.875 6.26621 16.875 6.36328V15.6797Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomentIcon);
export default __webpack_public_path__ + "static/media/moment-icon.d813d7120c2d69f9075558cfd7bf333c.svg";
export { ForwardRef as ReactComponent };